import { useAuth0 } from "@auth0/auth0-react";
import { useAppDispatch } from '../../app/hooks';
import { Page } from '../../Page';
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { setInvitationReference } from "./invitationSlice"; 

export function Invitation() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const { loginWithRedirect, isAuthenticated } = useAuth0()
    const { eventId } = useParams()
    const reference = window.atob(String(eventId))
    
    useEffect(() => {
        dispatch(setInvitationReference(reference))
        if (isAuthenticated)
            navigate('/')
        else
            loginWithRedirect()
    },[dispatch, isAuthenticated, loginWithRedirect, navigate, reference])
    
    
    return (
        <Page>
            <h1>Processing Invitation</h1>
        </Page>
    )
}
